module.exports = __webpack_public_path__ + "static/icon-rows-1b94a3f6a55e72d7e3c2486d0de9afbd.svg";